<template>
  <q-dialog v-model="open" @hide="clearUrl">
    <q-card>
      <img :src="fileUrl" />
      <div v-if="pdfUrl" style="margin-top: 20px">
        <iframe :src="pdfUrl" width="600px" height="600px" style="border: none"></iframe>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
import FileService from '@/services/FileService';

export default {
  mixins: [FileService],
  props: {
    // model: {}
  },

  data() {
    return {
      fileUrl: '',
      pdfUrl: '',
      open: false
    };
  },

  methods: {
    async getNfFileURL(fileId) {
      try {
        this.open = true;
        this.onLoading(true);
        const { data, headers } = await this.getFileContent(fileId);
        const content = headers['content-type'];

        if (content.includes('image')) {
          const base64 = this.arrayBufferToBase64(data);
          const imgSrc = 'data:image/png;base64,' + base64;
          this.fileUrl = imgSrc;
        } else {
          const blob = new Blob([data], { type: 'application/pdf' });
          const url = URL.createObjectURL(blob);

          // Guarda a URL no data para o iframe
          this.pdfUrl = url;
        }
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    arrayBufferToBase64(buffer) {
      let binary = '';
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },

    clearUrl() {
      this.fileUrl = '';
      this.pdfUrl = '';
    }
  }
};
</script>

<style></style>
